export default __webpack_public_path__ + "static/media/VertMore.879e686b.svg";